module.exports = __webpack_public_path__ + "static/step-1-69df3a30c8db1afbdf3547ffefb8068c.png";